import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { MagicLoader } from "../components/common";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { processOAuthSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");

    if (sessionId) {
      processOAuthSession(sessionId)
        .then(() => {
          toast.success("Welcome to StoryWeaver!");
          navigate("/dashboard", { replace: true });
        })
        .catch((err) => {
          toast.error("Authentication failed");
          navigate("/login", { replace: true });
        });
    } else {
      navigate("/login", { replace: true });
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <MagicLoader text="Completing sign in..." />
    </div>
  );
};

export default AuthCallback;
